import React from 'react';
import styles from './MultiSelectWithValidation.module.scss';
import Select from 'react-select';
import _ from 'lodash';
import {FiInfo} from "react-icons/fi";
import Tooltip from "../Tooltip/Tooltip";
import {$t} from "../../../helpers/translator";

class MultiSelectWithValidation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.selected ? props.selected : null,
            placeholder: this.props.placeholder ? this.props.placeholder : null,
        }
    }

    valueSelectedHandler(data) {
        let selection = {...data};

        _.forEach(this.props.options ? this.props.options : [], (v, k) => {
            if (v.value === selection.value) {
                selection.key = k;
            }
        })

        this.setState({value: selection}, () => {
            this.props.onValueChange({
                value: this.state.value,
                errors: this.props.required && !this.state.value ? 'required' : [],
            });
        })
    }

    render() {
        let options = this.props.options ? this.props.options : [];

        const customStyles = {
            control: (base, state) => ({
                ...base,
                background: "#f7f6f9",
                borderRadius: '5px',
                borderColor: "#dededf",
                boxShadow: '0 0.125rem 0.25rem #00000014',
                height: '40px'

            }),
            menu: base => ({
                ...base,
                borderRadius: 0,
                marginTop: '1px',
                zIndex: 9999
            }),
            menuList: base => ({
                ...base,
                padding: 0,
                zIndex: 9999
            }),
            menuPortal: base => ({
                ...base,
                zIndex: 9999
            }),
        };
        const onErrorStyles = {
            control: (base, state) => ({
                ...base,
                background: "#f7f6f9",
                borderRadius: '5px',
                borderColor: "#B42432FF",
                boxShadow: '0 0.125rem 0.25rem #00000014',
                height: '40px'

            }),
            menu: base => ({
                ...base,
                borderRadius: 0,
                marginTop: '1px',
                zIndex: 9999
            }),
            menuList: base => ({
                ...base,
                padding: 0,
                zIndex: 9999
            }),
            menuPortal: base => ({
                ...base,
                zIndex: 9999
            }),
        };

        /*
        const formatOptionLabel = ({ value, label, description }) => (
            <div style={{ display: "flex", flexDirection: 'column' }}>
              <div>{label}</div>
              <div style={{ color: "#ccc" }}>
                {description}
              </div>
            </div>
        );
        */

        const MyOption = props => {
            const { innerProps, innerRef } = props;
            const { label, description } = props.data;
            return (
              <div ref={innerRef} {...innerProps} className={[styles.option, props.isSelected && styles.active].join(' ')}>
                <div>{label}</div>
                {description && <div className={styles.description}>{description}</div>}
              </div>
            );
          };          

        return (
            <div>
                <div className={`${styles['container']}`}>
                    <Select
                        value={this.props.selected}
                        placeholder={this.state.placeholder}
                        closeMenuOnSelect={!this.props.multi}
                        className={`${styles['select']}`}
                        isMulti={!!this.props.multi}
                        options={options}
                        styles={this.props.touched && this.props.required && !this.state.value ? onErrorStyles : customStyles}
                        menuPosition={'fixed'}
                        isSearchable={this.props.searchable ? this.props.searchable : false}
                        onChange={(data) => this.valueSelectedHandler(data)}
                        isDisabled={this.props.disabled}
                        //formatOptionLabel={formatOptionLabel}
                        components={{Option: MyOption}}
                    />
                    {this.props.tooltip ?
                        <span className={styles.tooltip}>
                    <Tooltip content={this.props.tooltip}>
                        <FiInfo className={styles.infoIcon}/>
                    </Tooltip>
                </span>
                        :
                        null
                    }
                </div>
                {
                    this.props.touched && this.props.required && !this.state.value ?
                        <div className={`${styles.errorsContainerContainer}`}>
                            <div className={`${styles.error}`}>{$t('validation.general.required')}</div>
                        </div>
                        :
                        <div className={`${styles.errorsContainerContainer}`}>

                        </div>
                }
            </div>

        );
    }
}

export default MultiSelectWithValidation;
